

<div class="sus-planet list-circle padlist no-list circle-blue mb-footer">
    <!-- section 1 contents -->
    <div class="sec-1">
        <div class="container">
            <div class="row">
                <!-- title -->
                <div class="col-md-12 my-md-5 mb-5 sec-title">
                    <app-title-page [dataTitle]="dataTitle" [link]="'#planet-able'"></app-title-page>
                </div>
                <!-- detail -->
                <div class="col-md-12" id="planet-able">
                    <div class="lane-top pt-5">
                        <div class="row">
                            <div class="col-xl-5 col-lg-6 col-md-8">
                                <h6 class="mini-tit">{{ dataSection[0]?.title }}</h6>
                            </div>
                            <div class="col-md-12">
                                <div class="desc text-justify" [innerHTML]="dataSection[0]?.content"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
    <!-- section 2 contents -->
    <div class="sec-2 my-5">
        <div class="container bg-absolute d-md-block d-none">
            <div class="row">
                <div class="col-md-6 ml-auto pl-5">
                    <h4 class="f-subtit">{{ dataSection[1]?.title }}</h4>
                    <div class="desc text-justify mt-4" [innerHTML]="dataSection[1]?.content"></div>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-6 bg-headline"
                     [ngStyle]="{'background-image' : 'url('+ apiAsset + dataSection[1]?.picture +')'}">
                </div>
                <div class="col-md-6 bg-blue">
                    <div class="d-md-none d-block py-4">
                        <h4 class="f-subtit">{{ dataSection[1]?.title }}</h4>
                        <div class="desc text-justify mt-4" [innerHTML]="dataSection[1]?.content"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- section 3W contents  -->
    <div class="sec-3">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="accordion-grey">
                        <accordion [isAnimated]="true">
                            <accordion-group *ngFor="let accor of dataAccordion; let key = index">
                                <div class="title d-block" accordion-heading>
                                     {{ accor?.title }}
                                    <span class="icon"><i class="icon ion-ios-arrow-down"></i></span>
                                </div>
                                <div class="desc" [innerHTML]="accor?.description"></div>
                            </accordion-group>
                        </accordion>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

